import { Rocket, ArrowDown, Sparkles, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

const bullets = ["SEM TAXA POR PEDIDO", "FUNCIONA EM QUALQUER CELULAR", "PRONTO EM MINUTOS"];

export const Hero = () => {
  const navigate = useNavigate();
  return (
    <section id="topo" data-testid="hero-section" className="relative pt-16 pb-24 sm:pt-24 sm:pb-32 bg-brutal-cream overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: "radial-gradient(#0A0A0A 1.5px, transparent 1.5px)", backgroundSize: "24px 24px" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 bg-brutal-yellow border-[2.5px] border-brutal-black px-3.5 py-1.5 shadow-brutal-xs">
            <Sparkles size={14} strokeWidth={3} className="text-brutal-black" />
            <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-brutal-black">IA + WHATSAPP + IMPRESSORA</span>
          </div>
          <h1 className="mt-7 font-heading text-5xl sm:text-6xl lg:text-[5.5rem] tracking-tight text-brutal-black leading-[0.95] uppercase">
            O cliente<br />
            <span className="relative inline-block">
              <span className="relative z-10 text-brutal-black">ignorou</span>
              <span className="absolute left-0 right-0 bottom-1 h-4 sm:h-6 bg-brutal-pink -z-0" aria-hidden />
            </span>{" "}o cardápio?<br />
            <span className="text-brutal-blue">Nossa IA atende</span><br />
            <span className="bg-brutal-yellow border-[3px] border-brutal-black px-3 py-0.5 inline-block shadow-brutal -rotate-1 mt-2">por você.</span>
          </h1>
          <p className="mt-8 text-base sm:text-lg text-brutal-black leading-relaxed max-w-xl font-medium">
            Cardápio digital tão simples que qualquer cliente usa. Se ele preferir mandar mensagem, a IA anota o pedido direto no WhatsApp — <span className="bg-brutal-lime px-1 font-bold">sem você precisar parar o que está fazendo.</span>
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button data-testid="hero-register-cta" onClick={() => navigate("/login", { state: { register: true } })} className="bg-brutal-pink text-white border-[3px] border-brutal-black px-7 py-4 font-heading uppercase tracking-tight text-base shadow-brutal-md hover:translate-y-[-3px] hover:shadow-brutal-lg active:translate-y-[2px] active:shadow-brutal-sm transition-all inline-flex items-center justify-center gap-2">
              <Rocket size={20} strokeWidth={3} />Criar conta grátis
            </button>
            <a data-testid="hero-secondary-cta" href="#como-funciona" className="bg-white text-brutal-black border-[3px] border-brutal-black px-7 py-4 font-heading uppercase tracking-tight text-base shadow-brutal-sm hover:translate-y-[-3px] hover:shadow-brutal-md active:translate-y-[2px] active:shadow-brutal-xs transition-all inline-flex items-center justify-center gap-2">
              Como funciona<ArrowDown size={18} strokeWidth={3} />
            </a>
          </div>
          <ul className="mt-9 flex flex-wrap gap-2">
            {bullets.map((b) => (
              <li key={b} className="font-mono text-[10px] sm:text-xs font-bold uppercase tracking-wider text-brutal-black bg-white border-2 border-brutal-black px-2.5 py-1.5 shadow-brutal-xs inline-flex items-center gap-1.5">
                <Zap size={12} strokeWidth={3} className="text-brutal-pink" />{b}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-4 -left-4 w-28 h-28 bg-brutal-lime border-[3px] border-brutal-black -z-0 hidden lg:block" />
          <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-brutal-blue border-[3px] border-brutal-black -z-0 hidden lg:block" />
          <div className="relative border-[3px] border-brutal-black shadow-brutal-xl bg-white overflow-hidden">
            <img src="/screenshots/cardapio-mobile.png" alt="Cardápio digital real do Pede é Fácil no celular" className="w-full object-cover object-top max-h-[560px]" />
            <div className="absolute top-4 left-4 bg-brutal-yellow border-[2.5px] border-brutal-black px-3 py-1.5 shadow-brutal-sm">
              <p className="font-mono text-[10px] font-bold uppercase tracking-widest text-brutal-black">CARDÁPIO REAL</p>
            </div>
          </div>
          <div className="absolute -bottom-5 -right-2 sm:-right-5 bg-white border-[3px] border-brutal-black px-4 py-3 shadow-brutal-md z-20 rotate-2">
            <p className="font-mono text-[10px] font-bold uppercase tracking-widest text-brutal-pink">◉ PEDIDO RECEBIDO</p>
            <p className="mt-1 font-heading text-base text-brutal-black uppercase">Mesa 7 · R$ 86,50</p>
          </div>
        </div>
      </div>
    </section>
  );
};
